import { render, staticRenderFns } from "./ResourceDetail.vue?vue&type=template&id=059e8732&scoped=true"
import script from "./ResourceDetail.vue?vue&type=script&lang=js"
export * from "./ResourceDetail.vue?vue&type=script&lang=js"
import style0 from "./ResourceDetail.vue?vue&type=style&index=0&id=059e8732&prod&scoped=true&lang=css"
import style1 from "./ResourceDetail.vue?vue&type=style&index=1&id=059e8732&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059e8732",
  null
  
)

export default component.exports